import { ReactNode } from 'react';

import {
  MultipleChoiceListCorrect,
  MultipleChoiceListIncorrect,
} from '../multiple-choice';
import * as Styled from './multiple-choice-check.style';

import { ReactComponent as Tick } from 'lib/form/checkbox-input/tick.svg';

type Props = JSX.IntrinsicElements['input'] & {
  label?: ReactNode;
  disabled?: boolean;
  isCorrect?: boolean;
  isIncorrect?: boolean;
  isSelected?: boolean;
};

const MultipleChoiceCheckedSelectedAnswer = ({
  label,
  disabled,
  isCorrect,
  isIncorrect,
  isSelected,
}: Props) => {
  return (
    <Styled.MultipleChoiceCheckboxLabel $disabled={disabled} as="div">
      {isCorrect ? (
        <MultipleChoiceListCorrect />
      ) : isIncorrect ? (
        <MultipleChoiceListIncorrect />
      ) : isSelected ? (
        <Styled.MultipleChoiceCheckboxDecor $isSelected>
          <Tick width={16} height={16} />
        </Styled.MultipleChoiceCheckboxDecor>
      ) : (
        <>
          <Styled.MultipleChoiceCheckboxDecor>
            <Tick width={16} height={16} />
          </Styled.MultipleChoiceCheckboxDecor>
          <Styled.MultipleChoiceCheckboxFocus />
        </>
      )}
      {label}
    </Styled.MultipleChoiceCheckboxLabel>
  );
};

export default MultipleChoiceCheckedSelectedAnswer;
